import Client from '../services/kenticoClient';

class TaxonomyService {
  async fetchTaxonomy() {
    return Client.taxonomies().toPromise();
  }
}

export default new TaxonomyService();



// WEBPACK FOOTER //
// ./src/services/Taxonomy.service.js